import MaterialReactTable from 'material-react-table'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import oikosApi from '../../services/oikos/index'
import qs from 'qs'

function Atestados() {
  const [atestados, setAtestados] = useState([])

  const columns = [
    {
      accessorKey: 'atestado_id',
      header: 'ID',
      size: 100,
      accessorFn: (row) => {
        if (typeof row.atestado_id === 'number') {
          return row.atestado_id;
        } else {
          return 0; // Default value if it's missing or invalid
        }
      },
      Cell: ({ cell, row }) => {
        if (typeof row.original.atestado_id === 'number') {
          return row.original.atestado_id;
        } else {
          return 'Sem ID'; // Display placeholder if missing
        }
      },
    },
    {
      accessorKey: 'atestado_nome',
      header: 'Nome',
      size: 100,
      accessorFn: (row) => {
        if (row.atestado_nome && typeof row.atestado_nome === 'string') {
          return row.atestado_nome.trim();
        } else {
          return 'teste';
        }
      },
      Cell: ({ cell, row }) => {
        if (row.original.atestado_nome) {
          return row.original.atestado_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      accessorKey: 'proj_nome',
      header: 'Projeto',
      size: 100,
      accessorFn: (row) => {
        if (row.proj_nome && typeof row.proj_nome === 'string') {
          return row.proj_nome.trim();
        } else {
          return 'Sem Nome';
        }
      },
      Cell: ({ cell, row }) => {
        if (row.original.proj_nome) {
          return row.original.proj_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
  ];

  async function fetchAtestados() {
    const queryString = `/?${qs.stringify({
      action: 'get',
      table: 'atestado',
      fields: {
        "(SELECT proj_nome FROM proj WHERE proj.proj_id = atestado.proj_id)": "proj_nome",
      },
      data: {atestado_ativo: 1},
    })}`;

    const res = await oikosApi.get(queryString)

    setAtestados(res.data)

    return res.data
  }

  useEffect(()=>{
    fetchAtestados();
  }, [])

  return (
    <MaterialReactTable
      columns={columns}
      data={atestados}
      initialState={{
        density: 'compact',
        expanded: {}, //expand all groups by default
        pagination: { pageIndex: 0, pageSize: 50 },
        sorting: [], //sort by state by default
      }}
      enableGrouping={false}
      enableGlobalFilter={true}
      enableFilters={true}
      enablePagination={(atestados.length > 50)}
      muiTopToolbarProps={{
        sx: {
          '.button-fit-content': {'.MuiSvgIcon-root': {width: 'fit-content'}},
          '.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"},
          '.MuiSvgIcon-root': {width: '12px'},
          '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}
        }
      }}
      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
      muiTablePaginationProps={{
        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
        rowsPerPageOptions: [50, 100],
      }}
      muiTablePaperProps={{sx: {boxShadow: 'none'}}}
      positionPagination='bottom'
      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
      enableDensityToggle={false}
      enableColumnFilters={false}
      muiTableHeadCellProps={{
        sx: {
          '.MuiSvgIcon-root': {fontSize: "18px"},
          fontSize: '12px',
          fontWeight: 'normal', // Remove bold text in the header
          padding: '8px', // Adjust padding to reduce white space
        },
      }}
    />
  )
}

export default Atestados
